export enum addOrderAttachmentFormFields {
  orderAttachmentType = 'orderAttachmentType',
  documentLink = 'documentLink',
}
